import axios from 'axios';
import * as types from '../mutation-types';
import endpoints from "../endpoints";

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    // properties to store slots data
    endpoint: endpoints.slot.endpoint, // "slot",
    uploadedImage: endpoints.slot.uploadedImage,
    slots: [],
  },
  // -----------------------------------------------------------------
  getters: {
    // getters and computed props on the slots data
    uploadedImage: (state, getters, rootState, rootGetters) => rootGetters['global/apiUrl'] + "/" + state.uploadedImage,
    slots: state => state.slots,
    slotByID: state => id => {
      for (const slot of state.slots) {
        if (slot.id === id) return slot;
      }
      return undefined;
    },
  },
  // -----------------------------------------------------------------
  mutations: {
    [types.SUBTYPES_LOAD](state, slots) {
      state.slots = JSON.parse(JSON.stringify(slots));
    }
  },
  // -----------------------------------------------------------------
  actions: {
    fetch: (context, paginationData) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "s";

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: paginationData,
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            if (r.success) {
              if (r.data.rows == null) r.data.rows = [];
              context.commit(types.SUBTYPES_LOAD, r.data.rows);
            }
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    read: (context, id) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/" + id;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          method: 'GET'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    update: (context, slotData) => {
      context.commit(`cache/${types.CACHE_INVALIDATE}`, 'slots', {
        root: true
      });

      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/" + slotData.eid;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: slotData,
          method: 'PUT'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
  }
};
